import { CheckCircleTwoTone, CloseCircleTwoTone, PlusOutlined, EditOutlined } from '@ant-design/icons';

export const TrueIcon = <CheckCircleTwoTone style={{ fontSize: "20px" }} twoToneColor="#52c41a" />;
export const FalseIcon = <CloseCircleTwoTone style={{ fontSize: "20px" }} twoToneColor="#eb2f96" />;
export const AddIcon = <PlusOutlined />;
export const EditIcon = <EditOutlined style={{ fontSize: "15px",color:'green' }}/>
